module.exports = __webpack_public_path__ + "img/41-CAMICIA-PINOT-SML-COLORI-LINO--PANTALONE-RIESLING-SML-COLORI-LINO-STAMPE-LINO1.0e65f0bb.jpg";